import React, { Component } from 'react';
import CurrencyService from '../../../Services/CurrencyService';
import ButtonRow from '../../../Elements/ButtonRow';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import CurrencyAdminItem from '../../../Domain/CurrencyAdminItem';
import CurrencySearchParams from './CurrencySearchParams';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CurrencyWindowDescription from './CurrencyWindowDescription';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';

export default class CurrencyAdmin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shownPanel: ShownPanelsEnum.None,
      searchItem: new CurrencySearchParams(),
      selectedCurrency: null,
    };

    this.startSearch = this.startSearch.bind(this);
    this.showPanel = this.showPanel.bind(this);
    this.panelOnClose = this.panelOnClose.bind(this);
    CurrencyAdminItem.editFunction = this.editFunction.bind(this);
  }

  editFunction(id, currency) {
    this.setState({
      shownPanel: ShownPanelsEnum.EditItem,
      selectedCurrency: currency,
    });
  }

  renderButtonsAndPanels() {
    return (
      <>
        <ButtonRow
          colors={[ButtonColorsEnum.Primary]}
          tooltips={['Create']}
          keys={[ShownPanelsEnum.AddNewItem]}
          icons={['fa-solid fa-plus-circle']}
          roles={['Admin']}
          value={this.state.shownPanel}
          onClick={this.showPanel}
        />
        {this.renderPanels()}
      </>
    );
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderPanels() {
    if (this.state.shownPanel === ShownPanelsEnum.AddNewItem) {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Create}
          editedItem={new CurrencyAdminItem()}
          clickOnCancel={this.panelOnClose}
          clickOnSave={this.panelOnClose}
          windowDescription={CurrencyWindowDescription}
          errorCode='CUA63'
        />
      );
    } else if (this.state.shownPanel === ShownPanelsEnum.EditItem) {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={this.state.selectedCurrency}
          clickOnCancel={this.panelOnClose}
          clickOnSave={this.panelOnClose}
          windowDescription={CurrencyWindowDescription}
          errorCode='CUA72'
        />
      );
    }
  }

  panelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    this.refresh();
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  startSearch(searchItem) {
    this.setState({ searchItem });
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={CurrencyAdminItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={CurrencyService.GetCurrencyListWithDetails}
          convertDBItemsFunction={CurrencyService.ConvertDBCurrencyDetails}
          searchParamsType={CurrencySearchParams}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in Code and Description...'
          errorCode='CUA117'
        />
      </div>
    );
  }
}
